import { cn } from "@/lib/utils";

/**
 * Small badge for Win / Loss / Draw in the predictions table.
 */
export default function StatusBadge({ status }) {
  const map = {
    win: {
      label: "Win",
      cls: "bg-emerald-50 text-emerald-800 border-emerald-500/40",
    },
    loss: {
      label: "Loss",
      cls: "bg-red-50 text-red-800 border-red-400/40",
    },
    draw: {
      label: "Draw",
      cls: "bg-slate-100 text-slate-700 border-slate-300",
    },
  };
  const v = map[status] || map.draw;
  return (
    <span
      data-testid={`status-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-bold uppercase tracking-wider",
        v.cls
      )}
    >
      <span
        className={cn(
          "w-1.5 h-1.5 rounded-full",
          status === "win" && "bg-emerald-500",
          status === "loss" && "bg-red-500",
          status === "draw" && "bg-slate-400"
        )}
      />
      {v.label}
    </span>
  );
}
